class HeroSlider {
  constructor(container) {
    this.container = container;
    this.slides = Array.from(container.querySelectorAll('.hero-slider__slide'));
    this.dots = Array.from(container.querySelectorAll('.hero-slider__dot'));
    this.prevBtn = container.querySelector('.hero-slider__arrow--prev');
    this.nextBtn = container.querySelector('.hero-slider__arrow--next');
    this.currentIndex = 0;
    this.autoplay = container.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(container.dataset.autoplaySpeed, 10) || 5000;
    this.timer = null;

    if (this.slides.length <= 1) return;

    this.bindEvents();
    if (this.autoplay) this.startAutoplay();
  }

  bindEvents() {
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.goTo(this.currentIndex + 1);
        this.restartAutoplay();
      });
    }
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.goTo(this.currentIndex - 1);
        this.restartAutoplay();
      });
    }
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.dotIndex, 10);
        this.goTo(index);
        this.restartAutoplay();
      });
    });

    this.container.addEventListener('mouseenter', () => this.stopAutoplay());
    this.container.addEventListener('mouseleave', () => {
      if (this.autoplay) this.startAutoplay();
    });
  }

  goTo(index) {
    const total = this.slides.length;
    const newIndex = (index + total) % total;

    this.slides[this.currentIndex].classList.remove('is-active');
    this.dots[this.currentIndex] && this.dots[this.currentIndex].classList.remove('is-active');

    this.slides[newIndex].classList.add('is-active');
    this.dots[newIndex] && this.dots[newIndex].classList.add('is-active');

    this.currentIndex = newIndex;
  }

  startAutoplay() {
    this.timer = setInterval(() => {
      this.goTo(this.currentIndex + 1);
    }, this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  restartAutoplay() {
    this.stopAutoplay();
    if (this.autoplay) this.startAutoplay();
  }
}

document.querySelectorAll('.hero-slider').forEach((el) => new HeroSlider(el));